(function ($) {
	$(window).on("elementor/frontend/init", function () {});
})(jQuery);

window.addEventListener("DOMContentLoaded", () => {
	let revealer = document.querySelectorAll(".revealhidden");
	let miniatures = document.querySelectorAll(".miniature");
	let mainimage = document.querySelector(".mainimage");

	document.addEventListener("contextmenu", (e) => {
		e.preventDefault();
	});

	if (miniatures && mainimage) {
		miniatures.forEach((item) => {
			item.addEventListener("mouseover", () => {
				let url = item.dataset.url;
				mainimage.style.backgroundImage = "url(" + url + ")";
			});
			item.addEventListener("click", () => {
				let url = item.dataset.url;
				mainimage.style.backgroundImage = "url(" + url + ")";
			});
		});
		miniatures[0].click();
	}

	if (revealer) {
		revealer.forEach((item) => {
			item.addEventListener("click", () => {
				document.body.classList.add("extended");
			});
		});
	}
});
